import { Device, deviceSchema } from "@fatbees/schemas";

export async function putDevice(device: Device): Promise<void> {
  const response = await fetch(
    `/api/devices/${encodeURIComponent(device.id)}`,
    {
      method: "PUT",
      body: JSON.stringify({
        name: device.name,
        retiredAt: device.retiredAt,
      }),
      headers: { "content-type": "application/json" },
      credentials: "same-origin",
    },
  );
  if (!response.ok) {
    throw new Error(response.statusText);
  }
  deviceSchema.parse(await response.json());
}
